import { notify } from '@/utils'
import { AxiosError } from 'axios'

const onAxiosError = (err: AxiosError<string | { message: string }>) => {
  const errResp = err.response?.data
  const errMsg = err.message

  if (errResp) {
    const msg = typeof errResp === 'string' ? errResp : errResp?.message
    notify.error(msg)
  } else {
    notify.error(errMsg)
  }
}

const onDefaultError = (err: unknown) => {
  console.error(err)

  if (typeof err === 'string') {
    notify.error(err)
  } else {
    notify.error('Unexpected error')
  }
}

export const errorLog = (err: unknown, cb?: () => void) => {
  try {
    if (err instanceof AxiosError) {
      onAxiosError(err)
    } else {
      onDefaultError(err)
    }
  } finally {
    cb?.()
  }

  throw err
}
